import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BottombarLandingComponent } from './bottombar-landing.component';
import { ActualBottombarDataComponent } from './actual-bottombar-data/actual-bottombar-data.component';
import { ForecastBottombarDataComponent } from './forecast-bottombar-data/forecast-bottombar-data.component';
import { StockChartModule } from '../stock-chart-module/stock-chart/stock-chart.module';

@NgModule({
  declarations: [BottombarLandingComponent, ActualBottombarDataComponent, ForecastBottombarDataComponent],
  imports: [
    CommonModule,
    StockChartModule
  ],
  exports : [BottombarLandingComponent]
})
export class BottombarDataModuleModule { }
